module.exports = __webpack_public_path__ + "img/ElectricChargingStationV2.99803f26.png";